import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import '../../styles/popupBundler.scss';
import EcommerceApi from '../../api/EcommerceApi';
import CompatioApi from '../../api/CompatioApi';
import { assign as _assign, get as _get, forOwn as _forOwn } from 'lodash-es';
import Bundler from '../bundler-parts/Bundler';
//import styles from './styles.module.scss';
import ProductDescription from '../bundler-parts/ProductDescription';
import _ from 'lodash-es';
import { ProductCollectionFilter } from '../bundler-parts/ProductCollectionForFilter';
import AdditionalOptions from '../bundler-parts/AdditionalOptions';
import CompatioAnalytics from '../../api/CompatioAnalytics';

const popupStyles = {
  //position: 'fixed !important',
  boxShadow: '0 5px 30px rgba(0, 0, 0, 0.4)',
  border: '0px',
  padding: 0,
  maxWidth: '1180px',
  maxHeight: '780px',
  width: '100%',
};

const reelStyle = {
  position: 'fixed !important',
};

const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.75)',
};

/* TO-DO -
Logic to fetch the details of each category top two products from the data already fetched in compatioApi and ecommerceApi
We need to add logic to handle the promise as this method returns data in a promise
Use below code later instead of mock jsons above
If possible move this to some other file and make that common between product-list and bundlerPopup
*/
const getCategoryData = async (categories, eCommercePlatform) => {
  let catData = [];
  categories.forEach(async element => {
    element.products = element.products.slice(0, 100);

    let selectedMerchantProductSkus = CompatioApi.extractProductSkusByCategoryId(
      categories,
      element.categoryId
    );
    // console.log(categories,'categoriescategories',element.categoryId)

    let selectedProductData = await EcommerceApi.loadProductDataFromEcommerce(
      selectedMerchantProductSkus,
      eCommercePlatform,
      categories
    );

    let mergedProductData = CompatioApi.mergeCompatioDataWithProductData(
      selectedProductData.data,
      categories,
      element.compatioCategoryId
    );

    const productKey = 'compatioScore';
    let sortedProducts = mergedProductData.sort((productA, productB) => {
      let result = productA[productKey] > productB[productKey] ? 1 : -1;
      result *= -1;
      return result;
    });
    let CollapsedProducts = [];
    let group = _.groupBy(sortedProducts, 'parentProductId');
    _forOwn(group, (collapsedVariants, key) => {
      let options = [];
      collapsedVariants.forEach(variant => {
        options.push({
          id: variant.merchantProductSku,
          value: variant.variantTitle,
        });
      });
      let details = {
        compareAtPrice: collapsedVariants[0].compareAtPrice,
        currency: collapsedVariants[0].currency,
        options: options,
        description: collapsedVariants[0].productDescription,
        parentProductId: collapsedVariants[0].parentProductId,
        price: collapsedVariants[0].price,
        productHandle: collapsedVariants[0].productHandle,
        productName: collapsedVariants[0].productName,
        url_image: collapsedVariants[0].url_image,
        url_product: collapsedVariants[0].url_product,
      };
      CollapsedProducts.push({ product: key, productDetails: details });
    });
    let categoryObj = {
      categoryName: '',
      products: [],
    };
    categoryObj.categoryName = element.categoryName;
    let totalProducts = [];
    CollapsedProducts.forEach(collapsedProduct => {
      let productItem = element.products.find(
        el =>
          el.merchantParentProductId === collapsedProduct.product ||
          el.merchantProductId === collapsedProduct.product
      );
      if (productItem) totalProducts.push(collapsedProduct);
    });
    categoryObj.products = [...totalProducts.slice(0, 2)];
    catData.push(categoryObj);
  });

  return catData;
};

const bundlerProductDetails = async productCategoryData => {
  const eCommercePlatform =
    typeof _get(window, 'compatioConfig.shopify') === 'object' ? 'shopify' : '';
  let categories = Array.from(productCategoryData);
  // categories = categories.slice(0, 3);
  categories = categories;
  const tempData = await getCategoryData(categories, eCommercePlatform);

  // console.log(tempData,'categories')
  return tempData;
};

const optionData = _get(
  window,
  'compatioConfig.compatibleProducts.optionsData'
);

let defaultSelection = {};
// optionData.forEach(element => {
//   defaultSelection[element.optionId] = element.options[0].value;
// });
if (optionData && optionData.length > 0) {
  optionData.forEach(element => {
    defaultSelection[element.optionId] = element.options[0].value;
  });
}

const PopupCollection = props => {
  const { parentProduct, productData, parentProductSku, bundlerType } = {
    ...props,
  };
  // console.log(props,'props')
  const [Loading, setLoading] = useState(true);
  const [finalArray, setFinalArray] = useState([]);
  const [productList, setProductList] = useState([]);
  const [ProductDetails, setProductDetails] = useState([]);
  const [detailsModal, setDetailsModal] = useState({ show: false });
  const [optionsDetails, setOptionsDetails] = useState({ show: false });
  const [isParentReel, setIsParentReel] = useState(false);

  const handleClosePopup = close => {
    if (isReelAdded === 'true' && bundlerType != 'reelsoptions') {
      setOptionsDetails({
        show: true,
        details: defaultSelection,
        backingProduct: props.defaultBacking,
      });
    } else {
      close();
      props.toggleBundler();
    }
    if (optionsDetails.show) {
      close();
      props.toggleBundler();
    }
  };

  useEffect(() => {
    // console.log(parentProduct.variants.filter(e=>e.available == true)[0].id,'parentProduct.productSku')
    window.compatioConfig.compatibleProducts.methods.handleChangeProductSku(
      parentProduct.variants.filter(e => e.available == true)[0].id
    );
    if (bundlerType !== 'reelsoptions' && bundlerType != 'xrsoptions') {
      const productDetails = bundlerProductDetails(productData);
      // console.log(productData,'productDetails')
      productDetails.then(json => {
        setTimeout(function() {
          setLoading(false);
          setProductDetails(json);
        }, 2000);
      });
    } else {
      setLoading(false);
      setOptionsDetails({
        show: true,
        details: defaultSelection,
        backingProduct: props.defaultBacking,
      });
      setProductList(oldArray =>
        _.uniq([...oldArray, parentProductSku, props.bundledProduct])
      );
    }
  }, []);
  let ReelsData = finalArray.find(
    item =>
      //item.categoryName.toUpperCase().includes('REEL') && item.categoryName !== "Rod and Reel Cases"
      item.categoryName.toUpperCase() === 'REELS'
  );
  let isReelAdded = 'false';
  if (
    ReelsData != undefined ||
    bundlerType === 'reelsoptions' ||
    bundlerType === 'xrsoptions'
  ) {
    isReelAdded = 'true';
    if (ReelsData === undefined && productData != undefined) {
      ReelsData = {
        variantId: productData.variantId
          ? productData.variantId
          : productData.merchantProductSku,
        productName: productData.productName,
        productImage: productData.url_image,
        variantName: productData.variantName,
      };
    }
    if (
      ReelsData === undefined ||
      parentProduct.productName.toUpperCase().includes('REEL')
    ) {
      ReelsData = parentProduct;
      ReelsData.variantId = parentProduct.productSku;
    }
  }
  // console.log(
  //   parentProduct.type,
  //   'parentProduct',
  //   parentProduct.productName.toUpperCase().includes('REEL'),
  //   'parentProduct'
  // );
  // console.log(props,"props")
  // this below logic help to update the base product data in collection page XCS popup.
  window.compatioConfig.compatibleProducts.methods.handleProductDataUpdate(
    props.parentProduct
  );

  return (
    <Popup
      open={props.isOpen}
      modal
      position="top center"
      closeOnDocumentClick={false}
      closeOnEscape={false}
      contentStyle={popupStyles}
      overlayStyle={overlayStyle}
      className={bundlerType === 'reelsoptions' ? 'popup-xrs' : ''}
    >
      {close => (
        <div
          className="xrsbundler-modal closecollectionpop"
          popuptype={bundlerType}
        >
          <button
            className="close"
            style={{ zIndex: 2 }}
            onClick={() => handleClosePopup(close)}
          >
            &times;
          </button>
          <div className="condtent">
            <ProductCollectionFilter
              parentProduct={props.parentProduct}
              isReelAdded={isReelAdded}
              optionsDetails={optionsDetails}
              setOptionsDetails={setOptionsDetails}
              productDetails={ReelsData}
              popupType={bundlerType}
              isParentReel={parentProduct.type.toUpperCase().includes('REEL')}
              popCloseBox={props.toggleBundler}
            />

            {/* <div className="xrsBundled">
              <div
                className="categories"
                style={{
                  display:
                    detailsModal.show || optionsDetails.show ? 'none' : 'block',
                }}
              >
                <div className="xrs-header"> Add Compatible Products </div>
                {Loading ? (
                  <p>Loading</p>
                ) : (
                  <Bundler
                    CategoryData={ProductDetails}
                    setDetailsModal={setDetailsModal}
                    detailsModal={detailsModal}
                    setFinalArray={setFinalArray}
                    finalArray={finalArray}
                    productList={productList}
                    setProductList={setProductList}
                  />
                )}
              </div>
              <ProductDescription
                detailsModal={detailsModal}
                setDetailsModal={setDetailsModal}
              />
              {isReelAdded === 'true' ? (
                <AdditionalOptions
                  optionsDetails={optionsDetails}
                  setOptionsDetails={setOptionsDetails}
                  productDetails={ReelsData}
                  popupType={bundlerType}
                  isParentReel={parentProduct.productName
                    .toUpperCase()
                    .includes('REEL')}
                />
              ) : null}
            </div> */}
          </div>
          {/* <div
            className="xrsFooter"
            style={{ display: detailsModal.show ? 'none' : 'flex' }}
          >
            <div className="footer-content">
              <button
                id="xrs-continue"
                className="bundler-button"
                style={{ width: '200px', height: '35px' }}
                isreeladded={isReelAdded}
                productsadded={productList.length === 0 ? ' ' : productList}
                parentproductsku={parentProductSku}
                xrsuserid={CompatioAnalytics.getUserId()}
                reelid={
                  isReelAdded === 'true'
                    ? ReelsData.variantId
                      ? ReelsData.variantId
                      : ReelsData.merchantProductSku
                    : '-1'
                }
                additionaloptions={
                  optionsDetails.details !== undefined && isReelAdded
                    ? JSON.stringify(optionsDetails.details)
                    : ' '
                }
                backingproduct={
                  optionsDetails.backingProduct !== undefined && isReelAdded
                    ? optionsDetails.backingProduct
                    : ' '
                }
                onClick={() => handleClosePopup(close)}
              >
                {optionsDetails.show ? `Add to Cart` : `Continue to Cart`}{' '}
                <i className="arrow right" />{' '}
              </button>
            </div>
          </div> */}
        </div>
      )}
    </Popup>
  );
};

export default PopupCollection;
